export default [
  {
    title: '一、蒐集之目的：',
    items: [
      '（一）財產保險(依保險法令規定辦理之財產保險相關業務)。',
      '（二）人身保險(依保險法令規定財產保險經許可辦理之相關業務)。',
      '（三）其他經營合於營業登記項目或組織章程所定業務之需要。'
    ]
  },
  {
    title : '二、類別：包括但不限於姓名、身分證字號、出生年月日、住址、聯絡方式、婚姻、家庭、教育、職業、財務情況及其他得以直接或間接方式識別該個人之資料。',
    items: null
  },
  {
    title: '三、個人資料來源：',
    items: [
      '（一）要保人/被保險人。',
      '（二）司法警憲機關、委託協助處理理賠之公證人或機構。',
      '（三）當事人之法定代理人、輔助人。',
      '（四）各醫療院所。',
      '（五）與第三人共同行銷、交互運用客戶資料、合作推廣等關係、或於本公司各項業務內所委託往來之第三人。'
    ]
  },
  {
    title: '四、利用之期間、對象、地區及方式：',
    items: [
      '（一）期間：因執行業務所必須及法令規定應為保存之期間。',
      '（二）對象：\n1.本公司、與本公司簽訂合作推廣契約之保險代理人/保險經紀人、因辦理財產保險相關業務需要之第三方。\n2.本(分)公司及本公司海外分支機構、中華民國產物保險商業同業公會、中華民國人壽保險商業同業公會、財團法人保險事業發展中心、財團法人保險安定基金、財團法人住宅地震保險基金、財團法人汽車交通事故特別補償基金、財團法人金融消費評議中心、關貿網路股份有限公司、中央健康保險局、業務委外機構、與本公司有再保業務往來之公司、依法有調查權機關或金融監理機關。',
      '（三）地區：上述對象所在之地區。',
      '（四）方式：合於法令規定之利用方式。'
    ]
  },
  {
    title: '五、依據個資法第三條規定，台端就本公司保有台端之個人資料得行使之權利及方式：',
    items: [
      '（一）得向本公司行使之權利：\n1.向本公司查詢、請求閱覽或請求製給複製本。\n2.向本公司請求補充或更正。\n3.得向本公司請求停止蒐集、處理或利用及請求刪除。',
      '（二）行使權利之方式：以書面或其他日後可供證明之方式。'
    ]
  },
  {
    title: '六、台端不提供個人資料所致權益之影響（個人資料由當事人直接蒐集之情形適用）：',
    items: ['台端若未能提供相關個人資料時，本公司將可能延後或無法進行必要之審核及處理作業，因此可能婉謝承保、遲延或無法提供 台端相關服務或給付。']
  },
  {
    title: '七、關於您提供的個人資料，我們將就資訊系統及公司作業規則制定嚴格規範，任何人均須在我們明定的授權規範下才能處理及利用必要之資料。我們針對資料安全設備投注之保護措施如下：',
    items: [
      '1.我們採用最佳的科技來保障您的個人資料安全。目前以 Secure Sockets Layer(SSL) 機制(128bit)進行資料傳輸加密，並以加裝防火牆防止不法入侵，避免您的個人資料遭到非法存取。',
      '2.我們通過BSI國際認證公司驗證取得 ISO 27001資訊安全認證，以確保您的資料在多層的資訊安全控管下，做到最高規格的防護。'
    ]
  }
];